import SystemMessageTimeToolTip from './SystemMessageTimeToolTip';
import SystemMessageItem from './SystemMessageItem';
import SystemMessageContent from './SystemMessageContent';
import SystemMessageCenter from './SystemMessageCenter';
import SystemMessageEndContent from './SystemMessageEndContent';
import { IconCircle } from 'foundations-components/transitional/components/IconCircle';
import { InfoIcon } from 'foundations-assets';
import DashedLabel from '../atoms/DashedLabel';
import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import { View } from 'foundations-components/transitional/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const SystemMessage = ({
  timestamp,
  description,
  use = 'centered',
  icon = /*#__PURE__*/_jsx(IconCircle, {
    borderWidth: "0",
    icon: InfoIcon,
    size: "500"
  }),
  'data-test-id': dataTestId
}) => {
  return use === 'centered' ? /*#__PURE__*/_jsxs(DashedLabel, {
    transparent: true,
    "data-test-id": dataTestId,
    children: [/*#__PURE__*/_jsx(View, {
      display: "inline-block",
      marginInlineEnd: "100",
      children: description
    }), timestamp && /*#__PURE__*/_jsx(FormattedReactMessage, {
      message: "conversations-inbox-message-history.at-time",
      options: {
        timestamp: /*#__PURE__*/_jsx(SystemMessageTimeToolTip, {
          timestamp: timestamp
        })
      }
    })]
  }) : /*#__PURE__*/_jsxs(SystemMessageItem, {
    "data-test-id": dataTestId,
    children: [/*#__PURE__*/_jsx(SystemMessageCenter, {
      children: icon
    }), /*#__PURE__*/_jsx(SystemMessageContent, {
      children: description
    }), /*#__PURE__*/_jsx(SystemMessageEndContent, {
      children: timestamp && /*#__PURE__*/_jsx(SystemMessageTimeToolTip, {
        timestamp: timestamp
      })
    })]
  });
};
SystemMessage.displayName = 'SystemMessage';
export default SystemMessage;